import { history } from "../../src/index";

import * as types from '../constants/resolutiondetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as resolutiondetailsApi from '../api/resolutiondetails';

export function resetResolution() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_RESOLUTION_RESET });
    }
}

export function setResolutionDetails(data) {
    // console.log("getResolutionDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_RESOLUTION_REQUEST_COMPLETED, data: data });
    }
}

export function getResolutionDetails(id) {
    // console.log("getResolutionDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_RESOLUTION_REQUEST });
        resolutiondetailsApi.getResolution(id)
            .then(function (response) {
                // console.log("getResolutionDetails", response)
                dispatch({ type: types.FETCH_RESOLUTION_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getResolutionDetails Error", err)
                dispatch({ type: types.FETCH_RESOLUTION_REQUEST_ERROR });
            });
    }
}

export function getResolutionDetailsList(committee_id) {
    // console.log("getResolutionDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_RESOLUTION_LIST_REQUEST });
        resolutiondetailsApi.getResolutionList(committee_id)
            .then(function (response) {
                // console.log("getResolutionDetailsList", response)
                dispatch({ type: types.FETCH_RESOLUTION_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getResolutionDetailsList Error", err)
                dispatch({ type: types.FETCH_RESOLUTION_LIST_REQUEST_ERROR });
            });
    }
}

export function addResolutionDetails(objModel) {
    // console.log("addResolutionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_RESOLUTION_REQUEST });
        resolutiondetailsApi.addResolution(objModel)
            .then(function (response) {
                // console.log("addResolutionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_RESOLUTION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/resolution/resolution-list/' + objModel.committee_id);
                }
                dispatch({ type: types.ADD_RESOLUTION_RESET });
            })
            .catch(function (err) {
                // console.log("addResolutionDetails action err", err)
                dispatch({ type: types.ADD_RESOLUTION_REQUEST_ERROR });
            });
    }
}

export function updateResolutionDetails(objModel) {
    // console.log("updateResolutionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_RESOLUTION_REQUEST });
        resolutiondetailsApi.updateResolution(objModel)
            .then(function (response) {
                // console.log("updateResolutionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_RESOLUTION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/resolution/resolution-list/' + objModel.committee_id);
                }
                dispatch({ type: types.ADD_RESOLUTION_RESET });
            })
            .catch(function (err) {
                // console.log("updateResolutionDetails action err", err)
                dispatch({ type: types.ADD_RESOLUTION_REQUEST_ERROR });
            });
    }
}

export function updateFileDetails(resolutionid, objModel) {
    // console.log("updateFileDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.UPDATE_FILE_REQUEST });
        resolutiondetailsApi.updateFile(resolutionid, objModel)
            .then(function (response) {
                // console.log("updateFileDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.UPDATE_FILE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    // history.push('/resolution/add-resolution/' + resolutionid);
                }
            })
            .catch(function (err) {
                // console.log("updateFileDetails action err", err)
                dispatch({ type: types.UPDATE_FILE_REQUEST_ERROR });
            });
    }
}

export function deleteFileDetails(resolutionid, objModel) {
    // console.log("updateResolutionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_RESOLUTION_REQUEST });
        resolutiondetailsApi.deleteFile(objModel)
            .then(function (response) {
                // console.log("updateResolutionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_RESOLUTION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    // history.push('/resolution/add-resolution/' + resolutionid);
                }
            })
            .catch(function (err) {
                // console.log("updateResolutionDetails action err", err)
                dispatch({ type: types.ADD_RESOLUTION_REQUEST_ERROR });
            });
    }
}

export function deleteOrCloseResolutionDetails(resolutionId, status, committee_id) {
    // console.log(committee_id,"deleteOrCloseResolutionDetails action call",resolutionId,status);
    return dispatch => {
        dispatch({ type: types.ADD_RESOLUTION_REQUEST });
        resolutiondetailsApi.deleteOrCloseResolution(resolutionId, status)
            .then(function (response) {
                // console.log("deleteOrCloseResolutionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_RESOLUTION_REQUEST_COMPLETED });
                    let message = status == "Delete" ? "Deleted Successfully" : status == "Close" ? "Closed Successfully" : "Saved Successfully"
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: message });
                    history.push('/resolution/resolution-list/' + committee_id);
                }
                else if (response.status == 202)
                    dispatch({ type: types.ADD_RESOLUTION_REQUEST_ERROR });
            })
            .catch(function (err) {
                // console.log("deleteOrCloseResolutionDetails action err", err)
                dispatch({ type: types.ADD_RESOLUTION_REQUEST_ERROR });
            });
    }
}




// WEBPACK FOOTER //
// ./actions/resolutiondetails.js